export default function(api: GlobalFetch) {
  return async function() {
    const response: Response = await api.fetch('/api/v2/invoice/rates')
    const json: any = await response.json()
    return await json.items
  }
}
